<template>
  <div class="sign">
    <SignUpBody/>
    <SignUpFooter/>
  </div>
</template>
<script>
import TopModal from '@/components/modal/topModal';
import SignUpBody from './signUpBody';
import SignUpFooter from './signUpFooter';

export default {
  name: 'SignUp',
  components: {
    TopModal,
    SignUpBody,
    SignUpFooter
  },
  data() {
    return {
      details: {
        style: 'background: var(--blue70)',
        title: 'modal.top.free.title',
        description: 'modal.top.free.description',
        fromStart: '2021-07-09',
        toEnd: '2021-12-31'
      }
    }
  }
}
</script>